var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", {
        staticClass: "container-input",
        attrs: { label: "Custas processuais", showBorder: true }
      }),
      _c(
        "div",
        { staticClass: "custas" },
        [
          _c(
            "el-checkbox-group",
            {
              on: { change: _vm.handleChange },
              model: {
                value: _vm.custasVtn,
                callback: function($$v) {
                  _vm.custasVtn = $$v
                },
                expression: "custasVtn"
              }
            },
            _vm._l(_vm.tiposCustas, function(custa) {
              return custa.grupo === "PROCESSUAIS"
                ? _c(
                    "el-checkbox",
                    {
                      key: custa.id,
                      staticClass: "checkbox",
                      attrs: {
                        checked: _vm.selecionado(custa.id),
                        label: custa,
                        disabled: _vm.marcadoPadrao(custa.codigo)
                      }
                    },
                    [
                      _c("div", { staticClass: "label" }, [
                        _vm._v(_vm._s(custa.descricao))
                      ])
                    ]
                  )
                : _vm._e()
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-daa0002a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-daa0002a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustasVtn.vue
// module id = null
// module chunks = 